import {useDispatch} from "react-redux";

import {
  getOptionsData,
  getListData,
  getCurrenciesData,
  clearDownload,
  clearListState,
  clearColumnsState,
  reset,
} from "./index";

export const useCashierStatisticReport = () => {
  const dispatch = useDispatch();

  const getOptions = (data: any) => dispatch(getOptionsData(data));
  const getList = (data: any) => dispatch(getListData(data));
  const getCurrencies = (data: any) => dispatch(getCurrenciesData(data));
  const clearListData = () => dispatch(clearListState());
  const resetState = () => dispatch(reset());
  const clearDownloadState = () => dispatch(clearDownload());
  const clearColumns = () => dispatch(clearColumnsState());

  return {
    getOptions,
    getList,
    // setDownload,
    clearDownloadState,
    clearListData,
    resetState,
    getCurrencies,
    clearColumns,
  }
}
